export default __webpack_public_path__ + "static/media/v.60060f1f.svg";